import { render } from "./MyAccess.vue?vue&type=template&id=fff5edb8&scoped=true"
import script from "./MyAccess.vue?vue&type=script&lang=js"
export * from "./MyAccess.vue?vue&type=script&lang=js"

import "./MyAccess.vue?vue&type=style&index=0&id=fff5edb8&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff5edb8"]])

export default __exports__